import { useEffect } from 'react'

import { LanguageLocale } from '~/types/locale'

function useNoTranslate(): boolean {
  const language = typeof window !== 'undefined' ? window.navigator.language : undefined
  const languageCode = language?.slice(0, 2)
  const languageIsAppLanguage = languageCode && Object.values<string>(LanguageLocale).includes(languageCode)

  useEffect(() => {
    if (!languageIsAppLanguage) return

    const htmlElement = document.getElementsByTagName('html')[0]
    htmlElement.classList.add('notranslate')
    htmlElement.setAttribute('translate', 'no')
  }, [languageIsAppLanguage])

  return !languageIsAppLanguage
}
export default useNoTranslate
